/**
 * Voicemail utility functions for personalization
 */

/**
 * Get the current day of the week as a string
 * @returns Day name (e.g., "Monday", "Tuesday")
 */
export const getDayOfWeek = (): string => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[new Date().getDay()];
};

/**
 * Get the current part of the day
 * @returns "morning" (before 12pm), "afternoon" (12pm-5pm), or "evening" (after 5pm)
 */
export const getPartOfDay = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
};

/**
 * Determine if it's currently the weekend or weekday
 * Used for voicemail outros like "Have a great week/weekend!"
 * @returns "weekend" for Friday/Saturday/Sunday, "week" otherwise
 */
export const getWeekOrWeekend = (): string => {
  const day = new Date().getDay();
  // Friday (5), Saturday (6), Sunday (0) = weekend
  return day === 0 || day === 5 || day === 6 ? 'weekend' : 'week';
};
